<script setup lang="ts">
import { DdtButton, DdtToastHost } from '@ddt/ui';
import { RouterLink, RouterView, useRoute, useRouter } from 'vue-router';
import { NAV_GROUPS } from './nav';
import { useSession } from './stores/session';

const session = useSession();
const router = useRouter();
const current = useRoute();

async function logout() {
  await session.logout();
  await router.push({ name: 'login' });
}
</script>

<template>
  <header class="app-header">
    <span class="app-header__brand">O jogo · Painel admin</span>
    <div v-if="session.authenticated" class="app-user">
      <span data-testid="who">{{ session.account?.username }}</span>
      <DdtButton variant="ghost" size="sm" @click="logout">Sair</DdtButton>
    </div>
  </header>
  <div class="app-shell">
    <nav v-if="session.authenticated" class="side-nav" aria-label="Principal">
      <section v-for="g in NAV_GROUPS" :key="g.key" class="side-nav__group" :data-testid="`nav-${g.key}`">
        <h2 class="side-nav__title">{{ g.label }}</h2>
        <RouterLink v-for="l in g.links" :key="l.name" :to="{ name: l.name }" :class="{ 'router-link-active': l.activePrefix && current.path.startsWith(l.activePrefix) }">{{ l.label }}</RouterLink>
      </section>
    </nav>
    <main id="main" class="page-host">
      <div class="page">
        <!-- A chave remonta a tela ao trocar de rota que usa o mesmo componente (Dano e Arremesso e vento). -->
        <RouterView v-slot="{ Component, route }"><component :is="Component" :key="route.path" /></RouterView>
      </div>
    </main>
  </div>
  <DdtToastHost />
</template>
